"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var mobx_react_1 = require("mobx-react");
// ui elements
var DropDownMenu_1 = __importDefault(require("./DropDownMenu"));
var EditableTypography_1 = __importDefault(require("./EditableTypography"));
var AppLogo_1 = __importDefault(require("./AppLogo"));
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    grow: {
      flexGrow: 1
    },
    inputBase: {
      color: theme.palette.primary.contrastText
    },
    inputRoot: {
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      }
    },
    inputFocused: {
      borderColor: theme.palette.secondary.main,
      backgroundColor: theme.palette.primary.light
    }
  };
});
var AppToolbar = (0, mobx_react_1.observer)(function (_ref) {
  var session = _ref.session,
    _ref$HeaderButtons = _ref.HeaderButtons,
    HeaderButtons = _ref$HeaderButtons === void 0 ? react_1.default.createElement("div", null) : _ref$HeaderButtons;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var savedSessionNames = session.savedSessionNames,
    name = session.name,
    menus = session.menus;
  function handleNameChange(newName) {
    if (savedSessionNames === null || savedSessionNames === void 0 ? void 0 : savedSessionNames.includes(newName)) {
      session.notify("Cannot rename session to \"".concat(newName, "\", a saved session with that name already exists"), 'warning');
    } else {
      session.renameCurrentSession(newName);
    }
  }
  return react_1.default.createElement(material_1.Toolbar, null, menus.map(function (menu) {
    return react_1.default.createElement(DropDownMenu_1.default, {
      key: menu.label,
      menuTitle: menu.label,
      menuItems: menu.menuItems,
      session: session
    });
  }), react_1.default.createElement("div", {
    className: classes.grow
  }), react_1.default.createElement(material_1.Tooltip, {
    title: "Rename Session",
    arrow: true
  }, react_1.default.createElement(EditableTypography_1.default, {
    value: name,
    setValue: handleNameChange,
    variant: "body1",
    classes: {
      inputBase: classes.inputBase,
      inputRoot: classes.inputRoot,
      inputFocused: classes.inputFocused
    }
  })), HeaderButtons, react_1.default.createElement("div", {
    className: classes.grow
  }), react_1.default.createElement("div", {
    style: {
      width: 150,
      maxHeight: 48
    }
  }, react_1.default.createElement(AppLogo_1.default, {
    session: session
  })));
});
exports.default = AppToolbar;